// PII scrubbing for Sentry events (CHP-1127) — mirror of the backend
// `observability/sentry.py` scrubber. Runs as `beforeSend`, so it covers the
// whole outgoing payload including breadcrumbs. Identity on events is id +
// role only; anything email- or credential-shaped is redacted here as the
// last line of defence.

const REDACTED = "[redacted]";

const SENSITIVE_KEY_RE = /password|token|secret|authorization|cookie|api[_-]?key|credential|email/i;
const EMAIL_RE = /[\w.+-]+@[\w-]+\.[\w.-]+/g;
const BEARER_RE = /\bBearer\s+[\w.~+/=-]+/gi;

function scrubValue(value: unknown): unknown {
  if (typeof value === "string") {
    return value.replace(BEARER_RE, REDACTED).replace(EMAIL_RE, REDACTED);
  }
  if (Array.isArray(value)) {
    return value.map(scrubValue);
  }
  if (value !== null && typeof value === "object") {
    return Object.fromEntries(
      Object.entries(value as Record<string, unknown>).map(([key, entry]) =>
        SENSITIVE_KEY_RE.test(key) ? [key, REDACTED] : [key, scrubValue(entry)],
      ),
    );
  }
  return value;
}

// Typed loosely on purpose: Sentry's Event type is structurally a plain
// object; scrubbing recreates it with the same shape.
export function scrubEvent<T>(event: T): T {
  return scrubValue(event) as T;
}
